const ar = {
  common: {
    nav: { services: "الخدمات", about: "من نحن", guides: "الأدلة", contact: "تواصل معنا" },
    cta: "ابدأ مشروعك",
    language: "اللغة",
    themeToLight: "التبديل إلى الوضع الفاتح",
    themeToDark: "التبديل إلى الوضع الداكن",
    menuOpen: "فتح القائمة",
    menuClose: "إغلاق القائمة",
    optional: "اختياري",
    reply: "نرد خلال 7 ساعات.",
    scroll: "مرّر",
  },
  footer: {
    tagline: "أتمتة بالذكاء الاصطناعي ومواقع وتطبيقات للفرق التي تريد أن تتولى الأنظمة الأعمال المتكررة.",
    company: "الشركة",
    policies: "السياسات",
    elsewhere: "تابعنا",
    location: "بيكانير، راجستان، الهند · نعمل حول العالم",
    legal: {
      terms: "الشروط والأحكام",
      privacy: "سياسة الخصوصية",
      refund: "سياسة الاسترداد",
      return: "سياسة الإرجاع",
      cancellation: "سياسة الإلغاء",
      shipping: "سياسة الشحن",
    },
  },
  cookie: {
    title: "ملفات تعريف الارتباط بإذنك",
    body: "نستخدم ملفات تعريف الارتباط الضرورية لتشغيل الموقع. وبموافقتك نستخدم أيضًا ملفات التحليلات لتحسينه.",
    accept: "قبول الكل",
    reject: "الضرورية فقط",
    policy: "سياسة الخصوصية",
  },
  cta: {
    title: "هل لديك عملية يجب أن تعمل تلقائيًا؟",
    body: "أخبرنا بما تحتاجه. نرد خلال 7 ساعات.",
    primary: "ابدأ المحادثة",
    secondary: "استكشف الخدمات",
  },
  home: {
    hero: {
      eyebrow: "استوديو أتمتة بالذكاء الاصطناعي وبرمجيات",
      titleA: "نبني أنظمة",
      titleB: "تعمل من أجلك.",
      lede: "وكلاء ذكاء اصطناعي وأتمتة ومواقع وتطبيقات — من التصميم حتى الإطلاق.",
      primary: "ابدأ مشروعك",
      secondary: "شاهد أعمالنا",
      tags: ["وكلاء ذكاء اصطناعي", "أتمتة", "تطبيقات ويب", "تطبيقات جوال", "خطوط بيانات", "فيديو بالذكاء الاصطناعي"],
    },
    marquee: ["وكلاء ذكاء اصطناعي", "أنظمة RAG", "أتمتة سير العمل", "مواقع", "تطبيقات ويب", "تطبيقات جوال", "استخراج البيانات", "فيديو بالذكاء الاصطناعي", "Python", "n8n"],
    stats: [
      { value: 4, suffix: "+", label: "سنوات في بناء أنظمة الذكاء الاصطناعي" },
      { value: 100, suffix: "+", label: "سير عمل مؤتمت" },
      { value: 7, suffix: " س", label: "أقصى وقت للرد" },
    ],
    services: { label: "ماذا نقدم", title: "أربع طرق لمساعدتك.", more: "كل الخدمات" },
    work: {
      label: "أعمال مختارة",
      title: "مشاريع حقيقية أطلقناها.",
      intro: "افتح أي بطاقة لترى المشروع الفعلي.",
      nextLabel: "مشروعك",
      nextTitle: "قد يكون التالي.",
      nextBody: "مواقع وتطبيقات وأتمتة، من البداية إلى النهاية.",
      nextCta: "أخبرنا عنه",
      visit: "افتح الموقع في علامة تبويب جديدة",
    },
    process: {
      label: "طريقة عملنا",
      title: "من الفكرة إلى الإطلاق في أربع خطوات.",
      steps: [
        { title: "الاكتشاف", desc: "مكالمة مجانية لفهم هدفك." },
        { title: "التخطيط", desc: "خطة مكتوبة واضحة وجدول زمني." },
        { title: "البناء", desc: "نسخ تجريبية عاملة عند كل مرحلة." },
        { title: "الإطلاق", desc: "التشغيل الفعلي ثم الدعم." },
      ],
    },
    testimonials: { label: "آراء العملاء", title: "ماذا يقول عملاؤنا." },
  },
  services: {
    eyebrow: "الخدمات",
    title: "خدمات مركّزة مبنية حول هدفك.",
    lede: "يبدأ كل مشروع بمكالمة تعارف مجانية.",
    timeline: "المدة المعتادة",
    included: "ما يشمله",
    tools: "أدواتنا",
    showTools: "عرض الأدوات",
    hideTools: "إخفاء الأدوات",
    options: "طرق البدء",
    choose: "اختر",
    discuss: "ناقش مشروعك",
    extrasTitle: "متوفر أيضًا",
    extras: ["استشارات الذكاء الاصطناعي", "تصميم البنية", "تكامل واجهات API", "السحابة وDevOps", "الصيانة والدعم", "مهندسون مخصصون"],
    items: {
      "ai-automation": {
        title: "الأتمتة بالذكاء الاصطناعي",
        tagline: "وكلاء ومساعدون يرفعون العمل المتكرر عن فريقك.",
        timeline: "2–12 أسبوعًا",
        includes: ["تحليل العمليات", "روبوتات دردشة ووكلاء", "مساعدو المعرفة (RAG)", "التكامل مع CRM والأدوات", "30 يومًا من الدعم"],
        plans: [
          { name: "أتمتة مبدئية", note: "سير عمل واحد · 2–3 أسابيع" },
          { name: "حزمة أتمتة الأعمال", note: "عدة مسارات · 4–6 أسابيع" },
          { name: "أنظمة ذكاء اصطناعي للمؤسسات", note: "تكامل كامل · 8–12 أسبوعًا" },
        ],
      },
      "web-development": {
        title: "المواقع وتطبيقات الويب",
        tagline: "مواقع وتطبيقات سريعة وحديثة وسهلة الإدارة.",
        timeline: "1–10 أسابيع",
        includes: ["تصميم UI/UX", "تطوير متجاوب", "لوحة تحكم", "تحسين محركات البحث والأداء", "60 يومًا من الدعم"],
        plans: [
          { name: "موقع أعمال ثابت", note: "5–7 صفحات · 1–2 أسبوع" },
          { name: "موقع ديناميكي بلوحة تحكم", note: "لوحة تحكم · 3–4 أسابيع" },
          { name: "تطبيق ويب مخصص بالكامل", note: "ميزات مخصصة · 6–10 أسابيع" },
        ],
      },
      "python-automation": {
        title: "Python والبيانات",
        tagline: "سكربتات وأدوات استخراج وخطوط بيانات تعمل تلقائيًا.",
        timeline: "3 أيام–4 أسابيع",
        includes: ["سكربتات مخصصة", "استخراج بيانات الويب", "معالجة البيانات", "مهام مجدولة", "السجلات والتوثيق"],
        plans: [
          { name: "سكربت أتمتة بسيط", note: "مهمة واحدة · 3–5 أيام" },
          { name: "حل استخراج بيانات الويب", note: "صفحات متعددة · 1–2 أسبوع" },
          { name: "خط بيانات متقدم", note: "مصادر متعددة · 2–4 أسابيع" },
        ],
      },
      "ai-video": {
        title: "الفيديو والأفاتار بالذكاء الاصطناعي",
        tagline: "محتوى فيديو بكميات كبيرة دون محررين.",
        timeline: "2–10 أسابيع",
        includes: ["أفاتارات مخصصة", "توليد الصوت", "من النص إلى الفيديو", "هوية العلامة", "تدريب الفريق"],
        plans: [
          { name: "إعداد فيديو أساسي", note: "أفاتار واحد · 2–3 أسابيع" },
          { name: "نظام أفاتار احترافي", note: "استنساخ الصوت · 4–5 أسابيع" },
          { name: "منصة فيديو للمؤسسات", note: "API وعلامة بيضاء · 6–10 أسابيع" },
        ],
      },
    },
  },
  about: {
    eyebrow: "من نحن",
    title: "فريق صغير يبني ذكاءً اصطناعيًا عمليًا.",
    lede: "نستبدل العمل المتكرر بأنظمة موثوقة — من سكربت واحد إلى منصة كاملة.",
    storyLabel: "قصتنا",
    story: "أسسنا Optivra Tech لنقل الذكاء الاصطناعي الحديث إلى العمل اليومي. نفهم أولًا طريقة عملك، ثم نبني ما يناسبها.",
    valuesLabel: "ما يوجّهنا",
    values: [
      { title: "المهمة", desc: "نمو قابل للقياس عبر ذكاء اصطناعي وأتمتة عمليين." },
      { title: "الرؤية", desc: "الشريك التقني الذي تعتمد عليه الشركات النامية." },
      { title: "الالتزام", desc: "جودة في العمل، وضوح في التواصل، ونتائج حقيقية." },
    ],
    skillsLabel: "الخبرات",
    skillsTitle: "ما نجيده.",
    skillsHint: "مرّر المؤشر أو المس البطاقة لرؤية الأدوات.",
    skills: [
      { title: "الذكاء الاصطناعي وتعلم الآلة", tools: "OpenAI · LangChain · RAG · PyTorch" },
      { title: "الواجهة الخلفية", tools: "Python · FastAPI · Node.js · Django" },
      { title: "الواجهة الأمامية", tools: "React · Next.js · TypeScript · Tailwind" },
      { title: "البيانات", tools: "MongoDB · PostgreSQL · Redis · Pinecone" },
      { title: "السحابة", tools: "AWS · Google Cloud · Azure · Docker" },
      { title: "الأتمتة", tools: "n8n · Selenium · Scrapy · Airflow" },
    ],
    teamLabel: "الفريق",
    team: ["مهندسو ذكاء اصطناعي وأتمتة", "مطورو Full-stack", "مهندسو حلول", "مهندسو DevOps"],
    whyLabel: "لماذا نحن",
    why: [
      { title: "سرعة", desc: "دورات قصيرة ونسخ تجريبية عاملة." },
      { title: "حداثة", desc: "أدوات حديثة ومجربة." },
      { title: "إتقان", desc: "كود موثق وسهل الصيانة." },
    ],
  },
  contact: {
    eyebrow: "تواصل معنا",
    title: "لنتحدث.",
    lede: "أخبرنا عن مشروعك. نرد خلال 7 ساعات.",
    name: "الاسم الكامل",
    email: "البريد الإلكتروني",
    phone: "الهاتف",
    subject: "الموضوع",
    subjectPh: "مثال: أتمتة معالجة الفواتير",
    message: "الرسالة",
    messagePh: "ماذا تحتاج، وما الأدوات المستخدمة؟",
    send: "أرسل الرسالة",
    sending: "جارٍ الإرسال…",
    privacy: "لا نشارك بياناتك أبدًا.",
    okTitle: "تم إرسال الرسالة",
    okBody: "شكرًا! سنرد خلال 7 ساعات.",
    errTitle: "حدث خطأ ما",
    errBody: "تعذر إرسال الرسالة. حاول مرة أخرى.",
    emailLabel: "البريد",
    phoneLabel: "الهاتف",
    hoursLabel: "المواعيد",
    hours: "الإثنين–السبت، 9:00–19:00 بتوقيت الهند",
  },
  checkout: {
    eyebrow: "ابدأ مشروعك",
    title: "أخبرنا بما تحتاجه.",
    lede: "اختر الخيار الأقرب، وسنؤكد النطاق معك.",
    details: "بياناتك",
    project: "المشروع",
    name: "الاسم الكامل",
    company: "الشركة",
    email: "البريد الإلكتروني",
    phone: "الهاتف",
    service: "الخدمة",
    selectService: "اختر خدمة",
    option: "الخيار",
    selectOption: "اختر خيارًا",
    notes: "ملاحظات المشروع",
    notesPh: "ما الذي يجب أن يفعله؟ وبأي أدوات يتصل؟",
    agree: "أوافق على",
    and: "و",
    submit: "أرسل طلب المشروع",
    submitting: "جارٍ الإرسال…",
    summary: "الملخص",
    summaryService: "الخدمة",
    summaryOption: "الخيار",
    next: "نرد خلال 7 ساعات لتأكيد النطاق والخطوات التالية.",
    empty: "اختر خدمة وخيارًا.",
    perks: ["معالجة آمنة", "استرداد خلال 7 أيام", "رد خلال 7 ساعات"],
    refundLink: "سياسة الاسترداد",
    termsTitle: "الموافقة مطلوبة",
    termsBody: "يرجى قبول الشروط للمتابعة.",
    okTitle: "تم استلام الطلب",
    okBody: "شكرًا! سنتواصل معك خلال 7 ساعات.",
    errTitle: "حدث خطأ ما",
    errBody: "تعذر إرسال الطلب. حاول مرة أخرى.",
  },
  guide: {
    eyebrow: "الأدلة",
    title: "أدلة عملية من مشاريع حقيقية.",
    lede: "أدلة خطوة بخطوة في الذكاء الاصطناعي والأتمتة والمسار المهني.",
    badges: ["تنزيل PDF فوري", "نسخة عبر البريد", "دفع آمن عبر PhonePe"],
    listLabel: "الأدلة المتاحة",
    listTitle: "اختر دليلًا.",
    mins: "دقيقة",
    levels: { "All Levels": "كل المستويات", Beginner: "مبتدئ", Intermediate: "متوسط", Advanced: "متقدم" },
    choose: "اختر",
    selected: "تم الاختيار",
    items: {
      g0: "خطة من 30 إلى 45 يومًا للحصول على وظيفتك: السيرة الذاتية والمقابلات والتواصل.",
      g1: "نماذج الانتشار والعُقد المخصصة والنمذجة السريعة في ComfyUI.",
      g2: "ابنِ أنظمة ذاتية التشغيل تحل محل العمل اليدوي.",
      g3: "قواعد البيانات المتجهية والتقسيم ونشر وكلاء المعرفة.",
      g4: "استضف n8n وابنِ مسارات بين التطبيقات باستخدام webhooks.",
    },
    buyLabel: "الدفع",
    buyTitle: "احصل على نسختك.",
    buySub: "تُستخدم لإصدار فاتورتك وإرسال رابط التنزيل.",
    name: "الاسم الكامل",
    phone: "الهاتف",
    email: "البريد الإلكتروني",
    country: "الدولة",
    countries: { India: "الهند", "United States": "الولايات المتحدة", "United Kingdom": "المملكة المتحدة", Canada: "كندا", Australia: "أستراليا", Germany: "ألمانيا", Other: "أخرى" },
    gst: "رقم GST",
    company: "اسم الشركة",
    agree: "أوافق على",
    and: "و",
    terms: "الشروط والأحكام",
    refund: "سياسة الاسترداد",
    pay: "ادفع {amount} بأمان",
    redirecting: "جارٍ التحويل إلى الدفع…",
    buying: "أنت تشتري",
    format: "دليل PDF · تنزيل رقمي",
    price: "السعر",
    gstLine: "GST ({percent}%)",
    total: "الإجمالي",
    loadingPrice: "جارٍ تحميل السعر…",
    methods: "ادفع عبر UPI أو البطاقات أو الخدمات المصرفية أو المحافظ.",
    secure: "تتم معالجة المدفوعات بأمان عبر PhonePe.",
    faqLabel: "الأسئلة",
    faqTitle: "أسئلة شائعة.",
    faqs: [
      { q: "ما صيغة الأدلة؟", a: "ملف PDF يتضمن رسومًا توضيحية وأكوادًا وتعليمات خطوة بخطوة." },
      { q: "متى أستلمه؟", a: "فورًا. ستنتقل إلى صفحة التنزيل وتصلك نسخة عبر البريد." },
      { q: "هل يمكنني استرداد المبلغ؟", a: "الأدلة تنزيلات رقمية فورية، لذا الاسترداد محدود. راجع سياسة الاسترداد." },
      { q: "من يكتب الأدلة؟", a: "مهندسونا، من واقع الأنظمة التي يبنونها للعملاء." },
    ],
    errors: {
      "Full name is required": "الاسم الكامل مطلوب",
      "Email is required": "البريد الإلكتروني مطلوب",
      "Please enter a valid email": "أدخل بريدًا إلكترونيًا صالحًا",
      "Phone number is required": "رقم الهاتف مطلوب",
      "Please enter a valid phone number": "أدخل رقم هاتف صالحًا",
      "You must accept the terms": "يجب قبول الشروط",
      "Something went wrong. Please try again.": "حدث خطأ ما. حاول مرة أخرى.",
    },
  },
  success: {
    verifying: "جارٍ تأكيد الدفع…",
    pending: "لا تزال عملية الدفع قيد المعالجة",
    checking: "إعادة التحقق تلقائيًا ({n}/10)",
    checkAgain: "تحقق مرة أخرى",
    paid: "تم استلام الدفع. شكرًا لك!",
    downloads: "ملفاتك",
    dlGuide: "تنزيل الدليل (PDF)",
    dlInvoice: "تنزيل الفاتورة (PDF)",
    linksNote: "الروابط صالحة لمدة 24 ساعة، وأُرسلت نسخة إلى بريدك أيضًا.",
    expired: "انتهت صلاحية رابط التنزيل",
    failed: "تعذر إكمال العملية",
    support: "تواصل مع الدعم",
    home: "العودة إلى الرئيسية",
    errors: {
      "No order ID found. Please check your payment email for order details.": "لم يتم العثور على الطلب. راجع بريد الدفع لمعرفة التفاصيل.",
      "Payment failed. Please try again.": "فشل الدفع. حاول مرة أخرى.",
      "Unable to verify payment status.": "تعذر التحقق من حالة الدفع.",
      "Download links have expired after 24 hours.": "انتهت صلاحية روابط التنزيل بعد 24 ساعة.",
      "Unable to fetch download links.": "تعذر جلب روابط التنزيل.",
      "Download failed. Please try again or contact support.": "فشل التنزيل. حاول مرة أخرى أو تواصل مع الدعم.",
      "Something went wrong.": "حدث خطأ ما.",
    },
  },
  legal: { notice: "تُنشر هذه السياسة باللغة الإنجليزية، وهي النسخة الملزمة قانونيًا." },
  work: {
    kke: { kind: "موقع لعميل", summary: "موقع كتالوج متعدد اللغات لمورّد صناعي يصدّر إلى العالم.", highlights: ["الإنجليزية والفرنسية والعربية", "12 خط إنتاج", "طلبات عروض وواتساب"] },
    pokemac: { kind: "منتجنا · تطبيق macOS", summary: "تطبيق مرح في شريط القوائم يتفاعل مع النقر والغطاء ومنفذ USB.", highlights: ["تطبيق macOS أصلي", "يعمل على الجهاز"] },
    drillbuddy: { kind: "منتجنا · تطبيق Android", summary: "تمارين ردّ فعل صوتية للمصارعة وفنون القتال والريشة الطائرة.", highlights: ["Google Play", "شدة قابلة للتعديل"] },
    prayer: { kind: "منتجنا · تطبيق Android", summary: "عدّاد صلاة هادئ بسمات متعددة وتتبع يومي للتقدم.", highlights: ["8 لغات", "Google Play"] },
  },
};

export default ar;
